import { SHIFT } from 'shared/api';
import type { Bell, BellSchedule } from 'services/api';

export const bellScheduleCreateConfig: Partial<BellSchedule> = {
  bells: [
    {
      lessonIndex: 'FIRST',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'SECOND',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'THIRD',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'FOURTH',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'FIFTH',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'SIXTH',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'SEVENTH',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'EIGHTH',
      shift: SHIFT.MORNING,
    },
    {
      lessonIndex: 'FIRST',
      shift: SHIFT.AFTERNOON,
    },
    {
      lessonIndex: 'SECOND',
      shift: SHIFT.AFTERNOON,
    },
    {
      lessonIndex: 'THIRD',
      shift: SHIFT.AFTERNOON,
    },
    {
      lessonIndex: 'FOURTH',
      shift: SHIFT.AFTERNOON,
    },
    {
      lessonIndex: 'FIFTH',
      shift: SHIFT.AFTERNOON,
    },
    {
      lessonIndex: 'SIXTH',
      shift: SHIFT.AFTERNOON,
    },
    {
      lessonIndex: 'SEVENTH',
      shift: SHIFT.AFTERNOON,
    },
    {
      lessonIndex: 'EIGHTH',
      shift: SHIFT.AFTERNOON,
    },
  ] as BellSchedule['bells'],
};

export const MORNING_SHIFT_START_INDEX = 0;
export const AFTERNOON_SHIFT_START_INDEX =
  bellScheduleCreateConfig?.bells?.findIndex((bell: Bell) => bell.shift === SHIFT.AFTERNOON) ?? 8;

export const isShiftStartIndex = (index: number) =>
  index === MORNING_SHIFT_START_INDEX || index === AFTERNOON_SHIFT_START_INDEX;

export const getShiftRowSpan = (index: number) =>
  isShiftStartIndex(index) ? AFTERNOON_SHIFT_START_INDEX : MORNING_SHIFT_START_INDEX;
